import React from 'react';
import { Card } from '../../../components/atoms/Card';

import BuildingImg from './assets/building.png';
import DocumentImg from './assets/document.png';
import VideoCallImg from './assets/video-conference.png';
import { t } from 'i18next';

const CompaniesStatisticsScreen: React.FC = () => {
  return (
    <>
      <div className="flex flex-row justify-between w-full pb-3 border-b-[2px]">
        <div className="flex flex-col">
          <h2 className="text-[#0C1FAA] text-xl font-bold">{t('others.othDashboard')}</h2>
          <span className="text-[#727272] font-light">{t('others.othDashboard')}</span>
        </div>
      </div>

      <div className="flex flex-col mt-4 gap-4">
        <div className="flex flex-row justify-between gap-6">
          <Card.Root className="flex-1 border-[2px] border-solid border-[#E1E9EF]">
            <Card.Content className="justify-between">
              <div className="flex flex-row gap-2">
                <h3 className="font-bold text-lg text-[#0C1FAA]">Users to be approved by o2g</h3>
                <h3 className="font-bold text-5xl text-[#0C1FAA]">52</h3>
              </div>

              <img src={DocumentImg} alt="" />
            </Card.Content>
          </Card.Root>

          <Card.Root className="flex-1 border-[2px] border-solid border-[#E1E9EF]">
            <Card.Content className="justify-between">
              <div className="flex flex-row gap-2">
                <h3 className="font-bold text-lg text-[#0C1FAA]">Companies to be approved by RO</h3>
                <h3 className="font-bold text-5xl text-[#0C1FAA]">52</h3>
              </div>

              <img src={DocumentImg} alt="" />
            </Card.Content>
          </Card.Root>

          <Card.Root className="flex-1 border-[2px] border-solid border-[#E1E9EF]">
            <Card.Content className="justify-between">
              <div className="flex flex-row gap-2">
                <h3 className="font-bold text-lg text-[#0C1FAA]">FAQ/Questions to be answered</h3>
                <h3 className="font-bold text-5xl text-[#0C1FAA]">52</h3>
              </div>

              <img src={DocumentImg} alt="" />
            </Card.Content>
          </Card.Root>
        </div>

        <div className="flex flex-row justify-between gap-6">
          <Card.Root className="flex-1 border-[2px] border-solid border-[#E1E9EF]">
            <Card.Content className="justify-between">
              <div className="flex flex-row gap-2">
                <h3 className="font-bold text-lg text-[#0C1FAA]">New prospects from partners</h3>
                <h3 className="font-bold text-5xl text-[#0C1FAA]">52</h3>
              </div>

              <img src={DocumentImg} alt="" />
            </Card.Content>
          </Card.Root>

          <Card.Root className="flex-1 border-[2px] border-solid border-[#E1E9EF]">
            <Card.Content className="justify-between">
              <div className="flex flex-row gap-2">
                <h3 className="font-bold text-lg text-[#0C1FAA]">New sales requests</h3>
                <h3 className="font-bold text-5xl text-[#0C1FAA]">52</h3>
              </div>

              <img src={DocumentImg} alt="" />
            </Card.Content>
          </Card.Root>

          <Card.Root className="flex-1 border-[2px] border-solid border-[#E1E9EF]">
            <Card.Content className="justify-between">
              <div className="flex flex-row gap-2">
                <h3 className="font-bold text-lg text-[#0C1FAA]">Processes behind schedule</h3>
                <h3 className="font-bold text-5xl text-[#0C1FAA]">52</h3>
              </div>

              <img src={DocumentImg} alt="" />
            </Card.Content>
          </Card.Root>
        </div>
      </div>

      <div className="mt-4 flex gap-6">
        <Card.Root className="flex-1">
          <Card.Header>New Companies</Card.Header>

          <Card.Content className="flex-col justify-center items-center gap-4">
            <img src={BuildingImg} alt="" />

            <h3 className="font-bold text-xl text-[#0C1FAA]">We have 4 new companies</h3>

            <button className="bg-[#0C1FAA] text-white w-44 h-11 rounded-lg">Send more</button>
          </Card.Content>
        </Card.Root>

        <Card.Root className="flex-1">
          <Card.Header>New Companies</Card.Header>

          <Card.Content className="flex-col justify-center items-center gap-4">
            <img src={VideoCallImg} alt="" />

            <h3 className="font-bold text-xl text-[#0C1FAA]">
              We don&apos;t have shedule with specialist in this moment
            </h3>

            <button className="bg-[#0C1FAA] text-white w-44 h-11 rounded-lg">Send more</button>
          </Card.Content>
        </Card.Root>
      </div>
    </>
  );
};

export { CompaniesStatisticsScreen };
